import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { integrationsApi } from "../api/integrations.api";

import useToast from "@/lib/hooks/useToast";

export function useRevokeApiKey() {
  const { showToast } = useToast();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      integrationName,
      apiKeyId,
      tenantId,
    }: {
      integrationName: string;
      apiKeyId: string;
      tenantId: string;
    }) => {
      return await integrationsApi.revokeIntegrationApiKey(integrationName, apiKeyId, tenantId);
    },
    onError: (err: unknown) => {
      const error = err as {
        response?: { data?: { title?: string; detail?: string; error?: string; message?: string } };
        message?: string;
      };
      const errorData = error?.response?.data;
      const errorMessage =
        errorData?.detail ||
        errorData?.message ||
        error?.message ||
        t("integrations.modules.apiKey.revokeFailed", "Failed to revoke API key");
      showToast(errorMessage, "error");
    },
    onSuccess: () => {
      showToast(
        t("integrations.modules.apiKey.revoked", "API key revoked successfully"),
        "success"
      );
    },
    onSettled: (_data, _err, variables) => {
      // Refresh the key list (a key was removed).
      queryClient.invalidateQueries({
        queryKey: ["integrationApiKey", variables.integrationName, variables.tenantId],
      });
    },
  });
}
